<template>
  <section class="srch-page-top">
    <h1 class="srch-page-top--tit">제품검색</h1>
    <div class="container srch-area mt-7">
      <div class="srch-area--in">
        <search-box
          placeholdered="어떤 제품을 찾겠습니까?"
          class="srch-top"
          :value="searchWord"
          @search-data="searchData"
        />
        <h2 class="srch-area--recom mt-2">추천</h2>
        <div class="srch-area--recom-list mt-2">
          <a
            href=""
            class="srch-area--a"
            v-for="item in recommendedProduct"
            :key="item"
            @click.prevent="searchRcommendedProducts(item)"
          >
            #{{ item }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SearchBox from '@/components/page/SearchBox.vue';

export default {
  name: 'TopArea',
  components: {
    SearchBox,
  },
  props: {
    searchWord: {
      type: String,
      default: '',
    },
    recommendedProduct: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    searchData(input) {
      this.$store.dispatch('search/set', { searchedName: input });
      this.$emit('search-data', input);
    },
    searchRcommendedProducts(item) {
      this.$store.dispatch('search/set', { searchedName: item });
      this.$emit('search-data', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.srch-page-top {
  background: #f9f9f9;
  padding: 6rem 0;
  margin-top: -3.5rem;
  &--tit {
    text-align: center;
    font-size: 4rem;
    color: #1f1f1f;
    font-weight: 400;
  }
  .srch-area {
    width: 80rem;
  }
  @media (max-width: $mobile-size) {
    .srch-area {
      width: 100%;
    }
  }
  .srch-area--in {
    display: flex;
    flex-wrap: wrap;
  }
  .srch-top {
    width: 100%;
  }
  .srch-area--recom {
    width: 10%;
    font-size: 1.6rem;
    line-height: 1.5rem;
  }
  .srch-area--recom-list {
    width: 90%;
    line-height: 1.5rem;
  }
  .srch-area--a {
    color: #666;
  }
}
</style>
